import $ from "jquery";

function ResidenceSelect() {
  $(".js-residence-select").on("change", function () {
    var residence = $(this).closest(".js-residence"),
      addItem = residence.find(".js-residence-select-add");

    if ($(this).val() === "foreign") {
      addItem.show();
    } else {
      addItem.hide();
    }
  });
}

export { ResidenceSelect };
